module.exports = __webpack_public_path__ + "media/images/icons/icn_042-e50bae4c86f3853e8128e305d9e95302.svg";